import * as React from "react";
import classnames from "classnames";
import { SolutionsCTA } from "../../../../../../SolutionsCTA/modules/EcommContent/SolutionsEcommContent/components/SolutionsCTA/SolutionsCTA.js";
import { SolutionsUnitLabel } from "./SolutionsUnitLabel.js";
/* empty css                        */
import { StickyMobileCtaAndPrice } from "../../../../../../../../../StickyCta/modules/StickyCta/StickyMobileCtaAndPrice.js";
const SolutionsStickyCTA = ({ className }) => /* @__PURE__ */ React.createElement(
  StickyMobileCtaAndPrice,
  {
    className: classnames("solutions-sticky-cta", className),
    cta: /* @__PURE__ */ React.createElement(SolutionsCTA, null),
    priceSubtitle: /* @__PURE__ */ React.createElement(SolutionsUnitLabel, { className: "solutions-sticky-cta__subtitle" })
  }
);
export {
  SolutionsStickyCTA
};
//# sourceMappingURL=SolutionsStickyCTA.js.map
